import { useMutation } from '@tanstack/react-query'
import { MainService, MissionRead } from 'api/schema'
import { useNavigate } from 'react-router-dom'
import { PATH } from 'utils/constants'

const useDuplicateFullMission = () => {
  const navigate = useNavigate()

  return useMutation<MissionRead, Error, number>({
    mutationFn: MainService.mainMissionDuplicateFullCreate,
    onSuccess: newMission => navigate(`${PATH.MISSION}${newMission.id}`),
  })
}

export default useDuplicateFullMission